import React from "react";
import { Link } from "react-router-dom";
import styles from "./BrandStatement.module.css";

const BrandStatement = () => {
  return (
    <section className={styles.section}>
      <div className={styles.imageCol}>
        <img src="/media/r1 copy.jpg" alt="Sakha Design Lab Interior" />
        <div className={styles.badge}>
          <span className={styles.badgeNumber}>50+</span>
          <span className={styles.badgeLabel}>Projects Delivered</span>
        </div>
      </div>

      <div className={styles.textCol}>
        <span className={styles.tag}>WHO WE ARE</span>
        <h2 className={styles.headline}>
          Design is not just what it looks like —<br />
          <em>it's how it feels.</em>
        </h2>
        <p className={styles.body}>
          At Sakha Design Lab, we believe that every space holds a story waiting
          to be told. Founded with a passion for transforming interiors into
          experiences, we've spent years crafting homes and commercial spaces
          that resonate with the people who inhabit them.
        </p>
        <p className={styles.body}>
          From meticulous material selection to immersive 3D walkthroughs, our
          process ensures that every detail — no matter how small — is
          intentional, elegant, and built to last.
        </p>
        <Link to="/process" className={styles.cta}>
          Discover Our Process <span>→</span>
        </Link>
      </div>
    </section>
  );
};

export default BrandStatement;
